// Typelizer digest a84d84ef3c10dff9cb6cf3047d9ef607
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../../runtime'
import { buildUrl } from '../../../runtime'

export default {
  /** PATCH /c/:company_id/ledger/periods/:period_id/filing */
  update: (
    params: { periodId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'patch'> => ({
    url: buildUrl('/c/:company_id/ledger/periods/:period_id/filing', params, options),
    method: 'patch',
  }),

  /** POST /c/:company_id/ledger/periods/:period_id/filing */
  create: (
    params: { periodId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'post'> => ({
    url: buildUrl('/c/:company_id/ledger/periods/:period_id/filing', params, options),
    method: 'post',
  }),
}
